import SDK from '../SDK';
import { 
     INVALID_STORENAME } from "./Constants";
import { store } from '../Redux/store';
import { addImageLocalDB, checkBlob } from './localDB';

const substringBetween = (s, a, b) => {
    if(s.indexOf(b) === -1) {
       return s;
    }
    let p = s.indexOf(a) + a.length;
    return s.substring(p, s.indexOf(b, p));
}
const API_URL = store.getState()?.envData?.data?.apiBaseUrl
const mediaUrl = `${API_URL}/media/`;
class IndexedDb {    
   async localDBUsage(fileKey,blob){
        await addImageLocalDB(fileKey,blob)
    }

    
    async makeHttpRequet(key, storeName, fileKey, options = {}) {
        if(checkBlob(key)){
            return checkBlob(key)
        }
        const uniqueKey = substringBetween(key,mediaUrl,'?mf');
        const response = await SDK.getMediaURL(uniqueKey, fileKey);
        if (response.statusCode === 200) {
            /**
            // return this.setImage(uniqueKey, response.data.blob, storeName).then(()=>{
            //     return this.getImageByKey(uniqueKey, storeName, options)
            // });
             */
            await this.localDBUsage(key,response?.data?.blob)
            return response?.data?.blob
            }
           
    }        

     getImageByKey(keyString, storeName, fileKey, options) {
        if (!keyString) {
            return Promise.reject(null)
        }
        if (!storeName) {
            throw new Error(INVALID_STORENAME)
        }
        return this.makeHttpRequet(keyString, storeName, fileKey, options)            
    }


}

export default IndexedDb
